import { render, staticRenderFns } from "./ImpersonateBadge.vue?vue&type=template&id=31a4bff5&"
import script from "./ImpersonateBadge.vue?vue&type=script&lang=js&"
export * from "./ImpersonateBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports